import { ICompositeKeyFields } from "../formBuilder/interface";
import {
  IFormFieldSubmission,
  IFormSubmission,
  IFormSubmissionMap,
  IFormSubmissionSettings,
  IFormSubmissionsPaginationMap,
  IMySubmissions,
  ISubmissionMap,
  IFieldSubmissionMap,
  IUniversalStorageData,
  IRespondedBySubmissionMap,
  ICompositeKeyFieldResponse,
  IDataGridActionsMapper,
  IDataGridCompositeKeysValidationMapper,
  IFormSubmissionReducerState,
} from "./interface";

export const getActiveFormSubmissionSelector = (
  state: any
): IFormSubmission => {
  return state?.formSubmission?.activeFormSubmission;
};
export const getDataGridActionsMapperSelector = (
  state: any
): IDataGridActionsMapper => {
  return state?.formSubmission?.dataGridActionsMapper;
};

export const getDataGridCompositeKeysValidationMapper = (
  state: any
): IDataGridCompositeKeysValidationMapper => {
  return state?.formSubmission?.dataGridCompositeKeysValidationMapper;
};
export const getIsSamePageSelector = (
  state: any
): boolean => {
  return state?.formSubmission?.isSamePage;
};
export const getVisitedPagesSelector = (state: any): string[] =>
  state?.formSubmission?.visitedPages || [];

export const getIsDraftSelector = (state: any): boolean => {
  return state?.formSubmission?.isDraftSubmission ?? false;
};

export const getActiveFormFieldSubmissionFieldSubmissionMapSelector = (
  state: any
): IFieldSubmissionMap => {
  return (
    (state?.formSubmission?.activeFormSubmission &&
      state?.formSubmission?.activeFormSubmission?.fieldSubmissionMap) ||
    {}
  );
};

export const getReferenceCopyFormSubmissionMapSelector = (state:any) => {
  return state?.formSubmission?.referenceCopyFormSubmissionMap;
}
export const getFormSubmissionsMapSelector = (
  state: any
): IFormSubmissionMap => {
  return state?.formSubmission?.formSubmissionMap || {};
};

export const getSubmissionMapSelector = (state: any): ISubmissionMap => {
  return state?.formSubmission?.submissionMap || {};
};

export const getAddFormSubmissionLoaderSelector = (state: any): boolean => {
  return state?.formSubmission?.loaders?.addFormSubmission || false;
};

export const getaddFormSubmissionErrorSelector = (state: any): string => {
  return state?.formSubmission?.errors?.addFormSubmission || "";
};
export const getActiveFormSubmissionFieldDataSelector = (
  state: any,
  fieldId: string
): IFormFieldSubmission => {
  return state?.formSubmission?.activeFormSubmission?.fieldSubmissionMap?.[
    fieldId
  ];
};

export const getformSubmissionsPaginationMapSelector = (
  state: any
): IFormSubmissionsPaginationMap => {
  return state?.formSubmission?.formSubmissionsPaginationMap || {};
};

export const getfetchFormSubmissionsLoaderSelector = (state: any): boolean => {
  return state?.formSubmission?.loaders?.fetchFormSubmissions || false;
};

export const getFormSubmissionSettingsMapSelector = (
  state: any
): IFormSubmissionSettings => {
  return state?.formSubmission?.formSubmissionSettingsMap || {};
};

export const getfetchFormSubmissionSettingsErrorSelector = (
  state: any
): string => {
  return state?.formSubmission?.errors?.fetchFormSubmissionSettings || "";
};
export const getfetchFormSubmissionSettingsLoaderSelector = (
  state: any
): boolean => {
  return state?.formSubmission?.loaders?.fetchFormSubmissionSettings || false;
};

export const getMySubmittedFormsLoaderSelector = (state: any): boolean => {
  return state?.formSubmission?.loaders?.fetchMySubmissions || false;
};

export const getMySubmissionsSelector = (state: any): IMySubmissions => {
  return state?.formSubmission?.mySubmissions || {};
};

export const isSetActiveSubmissionLoader = (state: any): boolean => {
  return state?.formSubmission?.loaders?.setActiveFormSubmission || false;
};

export const getCheckDuplicateLoaderSelector = (state: any): boolean => {
  return state?.formSubmission?.loaders?.checkDuplicateSubmission || false;
};

export const getCheckDuplicateErrorSelector = (state: any): string => {
  return state?.formSubmission?.errors?.checkDuplicateSubmission || "";
};

export const getduplicateValueExistInSubmissionSelector = (
  state: any
): boolean => {
  return (
    state?.formSubmission?.activeFormSubmission?.duplicateValueExist || false
  );
};

export const getUniversalStorageUnit = (state: any): IUniversalStorageData => {
  return state?.formSubmission?.universalStorageUnit || {};
};

export const getIsFormBuilderAsComponent = (state: any): boolean => {
  return state?.formSubmission?.isFormBuilderAsComponent || false;
};
export const getFormSubmissionRespondedByData = (
  state: any
): IRespondedBySubmissionMap => {
  return state?.formSubmission?.respondedByDetails || {};
};

export const getCompositeFieldDataSelector = (
  state: any
): ICompositeKeyFieldResponse => {
  return (
    state?.formSubmission?.activeFormCompositeKeySubmission
      ?.compositeFieldSubmissionMap || []
  );
};

export const getCompositeFieldDuplicateErrorSelector = (
  state: any
): ICompositeKeyFieldResponse => {
  return (
    state?.formSubmission?.activeFormCompositeKeySubmission
      ?.isCompositeKeySuccess || false
  );
};

export const getFormFieldSubmissionData = (state: any): string[] => {
  return state?.formSubmission?.submissionDataOfFormField || [];
};

export const getFormOpenedDate = (state:any): string[] => {
  return state?.formSubmission?.openedDate || Date.now();
};

export const getdraftvalue = (state:any):boolean => {
  return state?.formSubmission.isDraftSubmission || false;
};

export const getOtpResponseSelector = (state: any): any => {
  return state?.formSubmission?.otpResponse ?? null;
};

export const getOtpLoadingSelector = (state: any): boolean => {
  return state?.formSubmission?.otpLoading || false;
};

export const getOtpErrorSelector = (state: any): string => {
  return state?.formSubmission?.otpError || "";
};